module.exports = __webpack_public_path__ + "static/media/clipboard-01.bc6fe089.png";